class UrlParams {
  constructor(url) {
    this.originalCasedNames = {};
    const queryString = url ? new URL(url).search : window.location.search;
    const urlParams = new URLSearchParams();
    new URLSearchParams(queryString).forEach((value, name) => {
      this.originalCasedNames[name.toLowerCase()] = name;
      urlParams.append(name.toLowerCase(), value);
    });
    this.urlParams = urlParams;
  }
  appendToUrl(url) {
    return url + "?" + this.toString();
  }
  delete(name) {
    this.urlParams.delete(name.toLowerCase());
  }
  get(name) {
    return this.urlParams.get(name.toLowerCase()) ?? void 0;
  }
  getBool(name) {
    return this.urlParams.get(name.toLowerCase()) === "1" || (this.urlParams.get(name.toLowerCase()) ?? "").toLowerCase() === "true";
  }
  getDate(name) {
    const value = this.urlParams.get(name.toLowerCase());
    const date = value ? new Date(value) : void 0;
    return !Number.isNaN(date == null ? void 0 : date.valueOf()) ? date : void 0;
  }
  getNumber(name) {
    const value = parseInt(this.urlParams.get(name.toLowerCase()) ?? "");
    return value && !isNaN(value) ? value : void 0;
  }
  set(name, value) {
    if (!(name.toLowerCase() in this.originalCasedNames)) {
      this.originalCasedNames[name.toLowerCase()] = name;
    }
    this.urlParams.set(name.toLowerCase(), value);
  }
  toString() {
    const urlParamsCasedNames = new URLSearchParams();
    this.urlParams.forEach((value, name) => {
      urlParamsCasedNames.append(this.originalCasedNames[name], value);
    });
    return urlParamsCasedNames.toString();
  }
  updateUrl() {
    window.history.replaceState(
      null,
      window.document.title,
      this.appendToUrl(window.location.pathname)
    );
  }
}
export {
  UrlParams as default
};
//# sourceMappingURL=UrlParams.js.map
